import React from 'react';
import { Col, Divider, Row, Space, Switch } from 'antd';
import { LayoutConfigs } from '../../constants';
import { renderInput } from './renderInput';
import get from 'lodash/get';
import { StyledFormItem } from './StyledItem';
import { Description, Label } from '../Elements';

const CommonTemplates = ({
  fields,
  rootName,
  sectionName,
  configs = [],
  readonly = false
}: any) => {
  const layoutConfig = get(LayoutConfigs, sectionName, []);

  const renderField = (fieldOrder: number, index: number) => {
    const field = fields.find((field: any) => field.order === fieldOrder);
    const fieldIndex = fields.findIndex(
      (field: any) => field.order === fieldOrder
    );
    const config = configs?.find(
      ({ fieldName }: any) => fieldName === field.name
    );

    return (
      <>
        <StyledFormItem
          label={
            <Space direction="horizontal" align="center">
              {field?.type === 'SECTION' && (
                <StyledFormItem
                  name={['fields', index, 'enabled']}
                  valuePropName="checked"
                >
                  <Switch disabled={readonly}></Switch>
                </StyledFormItem>
              )}
              <Label>
                {field?.type === 'SECTION'
                  ? `${field.label}`
                  : `#${fieldOrder} ${field.label}`}
              </Label>
            </Space>
          }
        >
          {field.description && <Description>{field.description}</Description>}
          {config &&
            renderInput(
              { ...config, field ,readonly},
              [...rootName, fieldIndex],
              `${field.name}-${config.fieldName}`
            )}
        </StyledFormItem>
        {field?.type === 'SECTION' ? <Divider></Divider> : null}
      </>
    );
  };
  return (
    <div>
      {layoutConfig.map(
        (fieldOrder: number | number[], layoutIndex: number) => {
          if (!Array.isArray(fieldOrder)) {
            return (
              <Row
                key={`field-${fieldOrder}`}
                justify="space-between"
                gutter={16}
              >
                <Col span={24}>{renderField(fieldOrder, layoutIndex)}</Col>
              </Row>
            );
          }

          return (
            <Row
              key={`field-${fieldOrder.join('-')}`}
              justify="space-between"
              gutter={16}
            >
              {fieldOrder.map((fOrder, index) => {
                return (
                  <Col key={`field-${fOrder}`} span={24 / fieldOrder.length}>
                    {renderField(fOrder, index)}
                  </Col>
                );
              })}
            </Row>
          );
        }
      )}
    </div>
  );
};

export default CommonTemplates;
